export default __webpack_public_path__ + "static/media/gallery7.730037e0.jpg";